import React, { FC } from 'react';

import Link from 'next/link';

import { ImgShadow, Src } from '@components/ImgShadow';
import { AIRDROP_PATHS } from '@constants/index';
import { I18n } from '@utils/index';

import styles from './index.module.less';

interface SendCardProps {
  src: Src;
  height: number;
  width: number;
}

export const SendCard: FC<SendCardProps> = (props) => {
  const { src, height, width } = props;
  return (
    <div className={styles.container}>
      <div className={styles.imgContainer}>
        <ImgShadow
          width={width}
          height={height}
          src={src}
          className={styles.img}
        />
      </div>
      <Link legacyBehavior href={AIRDROP_PATHS.SEND} passHref >
          <a>
          <div className={`${styles.goAirdrop} DINPro-Medium`} data-buried="send-airdrop">
            {I18n.t('PAnz7JcB')}
          </div>
          </a>
      </Link>
    </div>
  );
};
